import React from 'react';
import styles from './KeyImagesPanel.module.css';

export default function KeyImagesPanel({ keyImages = [], onJump }) {
  if (keyImages.length === 0) {
    return <div className={styles.empty}>No key images yet. Press <kbd>K</kbd> to mark the active image.</div>;
  }
  return (
    <ul className={styles.list}>
      {keyImages.map(ki => (
        <li key={ki.id} className={styles.row}>
          <button className={styles.jump} onClick={() => onJump?.(ki.image_index)}>
            <span className={styles.star}>★</span>
            <span className={styles.idx}>#{ki.image_index + 1}</span>
            {ki.note ? <span className={styles.note}>{ki.note}</span> : <span className={styles.noteMuted}>(no note)</span>}
          </button>
          <span className={styles.by}>{ki.marked_by}</span>
        </li>
      ))}
    </ul>
  );
}
